import React, { Component } from 'react';
import { Container, Row, Col, CardGroup, Card, CardBody, InputGroup, Input } from 'reactstrap';
import { Switch, Route, Redirect } from 'react-router-dom';
import LaddaButton, {
    ZOOM_OUT
} from 'react-ladda';
import { Button, Icon, Modal } from 'antd';
import { urlapi, token, set_cookie, logo, getExpiredDate } from '../../../config';


class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            btnLoginloading: false,
            username: "",
            password: "",
            errormessage: "",
        }

        this.getCookie = this.getCookie.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this._handleKeyPress = this._handleKeyPress.bind(this);
        this.handleShowPassword = this.handleShowPassword.bind(this);
    }

    componentDidMount() {

        this.getCookie("__AntiXsrfUerkey");
    }

    getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }

            if (c.indexOf(name) == 0) {
                if (name == "__AntiXsrfUerkey=") {
                    this.props.history.push("/dashboard");
                }
            }
        }
        return "";
    }

    handleLogin(e) {
        e.preventDefault();
        this.toggle('btnLoginloading');
        this.setState({ errormessage: "" });
        if (this.state.username != "" && this.state.password != "") {
            let now = new Date();
            let time = now.getTime();
            // let expireTime = time + 1 * 3600 * 1000;
            let expireTime = time + 60 * 1000;
            now.setTime(expireTime);

            let req = JSON.stringify({
                "username": this.state.username,
                "password": this.state.password,
                // "expireMinutes": "1140"
            });

            fetch(urlapi + "api/Token", {
                crossDomain: true,
                method: 'POST',
                headers: {
                    "Content-type": "application/json; charset=UTF-8"
                },
                body: req
            })
                .then(function (data) {
                    if (data.ok) {
                        data.json().then(function (json) {
                            let Token = "__AntiXsrfUerkey=" + encodeURIComponent(json.tokenString);
                            let ExpiredDate = getExpiredDate(Token).toGMTString();
                            let SendToken = Token + ";expires=" + ExpiredDate + ";path=/";
                            set_cookie(SendToken);
                            this.toggle('btnLoginloading');
                            this.props.history.push("/dashboard");
                        }.bind(this));
                    } else {
                        data.text().then(function (text) {
                            console.log('error ', text);
                            this.setState({ errormessage: 'Username or password is incorrect.' });
                            this.toggle('btnLoginloading');
                        }.bind(this));

                    }
                }.bind(this)
                ).catch(function (err) {
                    Modal.error({
                        content: 'Error on the internal server',
                    });
                }.bind(this));
        } else {
            this.setState({ errormessage: "Username or Password is incorrect." });
            setTimeout(() => {
                this.toggle('btnLoginloading')
            }, 10);
        }
    }

    toggle(name) {
        this.setState({
            [name]: !this.state[name]
        })
    }

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.handleLogin(e);
        }
    }

    handleShowPassword() {
        this.setState({ showPassword: !this.state.showPassword });

    }

    render() {
        const { btnLoginloading, errormessage, showPassword } = this.state;
        return (
            <div className="app flex-row align-items-center login-background">
                <Container className="container-login">
                    <img src={logo + "img/logo.png"} className="login-logo" />
                    <Row className="justify-content-left">
                        <Col md="6">
                            <CardGroup>
                                <Card className="p-4" className="login-card">
                                    <CardBody>
                                        <h1 className="login-titel">Login to LON account</h1>

                                        <h5>Username</h5><p />
                                        <InputGroup className="mb-3">

                                            <input type="text" className="input-login"
                                                ref={(input) => { this.inputusername = input; }}
                                                name="username" placeholder="Please enter you username" onChange={this.handleChange} onKeyPress={this._handleKeyPress} />
                                        </InputGroup>

                                        <h5>Password</h5><p />
                                        <InputGroup className="mb-3">
                                            <input type={showPassword ? "text" : "password"} className="input-login"
                                                ref={(input) => { this.inputpassword = input; }}
                                                name="password" onChange={this.handleChange} onKeyPress={this._handleKeyPress} placeholder="Please enter you password" />
                                            <Icon onClick={this.handleShowPassword} type={showPassword ? "eye" : "eye-invisible"} className="showpassword" />
                                        </InputGroup>

                                        <Row>
                                            <Col xs="12">
                                                <Button type="primary" style={{ marginRight: 8, float: 'right' }} loading={btnLoginloading} onClick={this.handleLogin}>
                                                    Login
                                                </Button>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col xs="12" style={{ textAlign: "right" }}>
                                                <label for={errormessage} style={{ color: "red" }}>{errormessage}</label>
                                            </Col>
                                        </Row>

                                    </CardBody>
                                </Card>
                            </CardGroup>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js